import type { Quote } from "./types";
import { createQuoteStory } from "./types";

export const urusanMukmin: Quote = {
  id: "urusan-mukmin-muslim",
  name: "Urusan Mukmin Selalu Baik",
  emoji: "✨",
  category: "Sabar & Tawakkal",
  description:
    "Semua urusan seorang mukmin adalah baik — bersyukur saat senang dan bersabar saat susah, keduanya **menghasilkan kebaikan**.",
  detail:
    "Hadits ini diriwayatkan oleh Imam Muslim dari sahabat Shuhaib radhiyallahu 'anhu. Rasulullah ﷺ menjelaskan bahwa seorang mukmin selalu dalam posisi menang: senang bersyukur, susah bersabar. **Kedua respons ini menghasilkan kebaikan.** Ini hanya berlaku bagi orang beriman yang menjadikan iman sebagai kompas hidupnya.",
  tldr: "Senang bersyukur, susah bersabar — mukmin selalu menang.",
  story: createQuoteStory("Urusan Mukmin Selalu Baik", "✨", [
    { hook: {
      title: "Pernah merasa hidup cuma kasih dua pilihan?",
      body: "Senang atau susah. Tapi Rasulullah ﷺ bilang: **buat seorang mukmin, dua-duanya itu menang.**",
    } },
    { source: {
      body: "Sungguh menakjubkan urusan seorang mukmin. Semua urusannya adalah **baik baginya**. Hal ini tidak didapatkan kecuali pada diri seorang mukmin. Apabila mendapatkan **kesenangan**, dia **bersyukur**, maka itu kebaikan baginya. Apabila tertimpa **kesusahan**, dia **bersabar**, maka itu pun kebaikan baginya.",
      title: "HR. Muslim no. 2999",
    } },
    { reveal: {
      body: "Hidup nggak pernah janji cuma kasih yang enak. Tapi hadits ini bilang: **bukan situasinya yang menentukan**, melainkan **responsmu**. Syukur saat senang, sabar saat susah — dan keduanya berujung pada kebaikan.",
    } },
    { insight: {
      title: "Dua respons, satu hasil",
      body: "Senang datang → **bersyukur** → kebaikan.\nSusah datang → **bersabar** → kebaikan.\n\nIman adalah **kompas** yang mengubah kedua situasi jadi ladang pahala.",
    } },
    { engagement: {
      title: "Kamu lagi di momen syukur atau sabar?",
      body: "Kalau lagi senang, itu kesempatan **bersyukur**. Kalau lagi susah, itu kesempatan **bersabar**. Apapun yang sedang kamu hadapi sekarang — kamu tetap dalam kebaikan.",
    } },
  ]),
  related: ["sabar-baqarah-153"],
};
